type IdentityProvider = {
  name: string;
  config: {
    [key: string]: string;
  };
  isEnabled: boolean;
};

const identityProvider: IdentityProvider = {
  name: "",
  config: {},
  isEnabled: false,
};

export type { IdentityProvider };

export { identityProvider };
